import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { MessageService } from '@mds/angular-layout-primeng';
import { Observable, map } from 'rxjs';
import { OrganizationSwitchService } from '../services/organization-switch.service';

@Injectable({
  providedIn: 'root',
})
export class OrganizationGuard implements CanActivate {
  constructor(
    private readonly organizationSwitchService: OrganizationSwitchService,
    private readonly messageService: MessageService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const orgId = route.paramMap.get('orgId');

    return this.organizationSwitchService.getOrganization().pipe(
      map((organization) => {
        if (orgId != null && organization?.value != orgId) {
          this.organizationSwitchService.switchOrganization(orgId, state.url);
          return true;
        }

        if (organization) {
          return true;
        }

        this.messageService.add({
          severity: 'info',
          textResource: _('Iam.OrganizationSwitch.Notification.NoneActive.Info'),
        });
        this.organizationSwitchService.openOrganizationSwitch();
        return false;
      })
    );
  }
}
